'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _typeToReducer;

var _typeToReducer2 = require('type-to-reducer');

var _typeToReducer3 = _interopRequireDefault(_typeToReducer2);

var _arrayAsObj = require('shared/utils/arrayAsObj');

var _arrayAsObj2 = _interopRequireDefault(_arrayAsObj);

var _types = require('shared/modules/App/types');

var _types2 = require('shared/redux/middlewares/geocoding/types');

var _getAnticipatoryJobs = require('./getAnticipatoryJobs');

var _getAnticipatoryJobs2 = _interopRequireDefault(_getAnticipatoryJobs);

var _check = require('./check');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
  interests: {},
  skills: {},
  educationLevels: {},
  subsectors: {},
  geocodedLocations: {},
  jobs: {},
  advisors: {},
  employers: {},
  educators: {}
};

var transformLocation = function transformLocation(_ref) {
  var location = _ref.location,
      key = _ref.key;

  if (key && location) {
    var lat = location.lat,
        lng = location.lng;


    return {
      lat: lat,
      lng: lng
    };
  }

  return {};
};

var parseJob = function parseJob(job) {
  return (0, _extends4.default)({}, job, {
    interests: (0, _arrayAsObj2.default)(job.interests.map(function (interest) {
      return {
        id: interest.id,
        value: interest.value,
        critical: interest.critical
      };
    })),
    skills: (0, _arrayAsObj2.default)(job.skills),
    education: job.education,
    anticipatory: [],
    fullSlug: '/job/' + job.slug,
    shortDesc: job.shortDesc || ''
  });
};

/*
const getSomeFakeJobs = (jobs) => {
  const fakeIt = (key, payload) => {
    return {
      [key]: {
        ...jobs[key],
        ...payload,
      },
    };
  };
  return {
    ...jobs,
    ...fakeIt('credit-analyst', () => ({
      //promotional: job.promotional.concat(['underwriters', 'courier']),
      promotional: ['courier'],
      transitional: ['compliance-officer'],
    })),
    ...fakeIt('cash-manager', job => ({
      promotional: job.promotional.concat('credit-analyst'),
    })),
    ...fakeIt('underwriters', job => ({
      transitional: job.transitional.concat('atm-manager'),
      promotional: job.promotional.concat('banking-admin'),
    })),
  };
};
*/

var getJobsBySlug = function getJobsBySlug(_ref2) {
  var jobs = _ref2.jobs;

  var parsedJobs = (0, _arrayAsObj2.default)(jobs.map(parseJob), 'slug');

  // this is simply to work around the data from Craft, for the Job
  // Career Map
  //const fakeJobs = getSomeFakeJobs(parsedJobs);

  // sanity check to make sure the promo and transitional fields
  // are not pointing to invalid jobs
  return (0, _check.checkTransitional)((0, _check.checkPromotional)(parsedJobs));
};

exports.default = (0, _typeToReducer3.default)((_typeToReducer = {}, (0, _defineProperty3.default)(_typeToReducer, _types2.GEOCODE_LOCATIONS_FULFILLED, function (state, action) {
  var geocodedLocations = (0, _arrayAsObj2.default)(action.locations, 'key', transformLocation);

  return (0, _extends4.default)({}, state, {
    geocodedLocations: (0, _extends4.default)({}, state.geocodedLocations, geocodedLocations)
  });
}), (0, _defineProperty3.default)(_typeToReducer, _types.GET_APP, {
  FULFILLED: function FULFILLED(state, _ref3) {
    var response = _ref3.response;

    var jobsBySlug = getJobsBySlug(response);

    return (0, _extends4.default)({}, state, {
      jobs: (0, _getAnticipatoryJobs2.default)(jobsBySlug),
      educationLevels: (0, _arrayAsObj2.default)(response.education, 'bookCount', function (education) {
        return {
          label: education.title
        };
      }),
      skills: (0, _arrayAsObj2.default)(response.skills, function (_ref4) {
        var title = _ref4.title;
        return {
          label: title
        };
      }),
      interests: (0, _arrayAsObj2.default)(response.interests, function (_ref5) {
        var title = _ref5.title;
        return {
          label: title
        };
      }),
      subsectors: (0, _arrayAsObj2.default)(response.subsectors, function (_ref6) {
        var title = _ref6.title,
            contentTitle = _ref6.contentTitle,
            slug = _ref6.slug;

        return {
          label: title,
          fullSlug: '/subsector/' + slug,
          slug: slug,
          contentTitle: contentTitle
        };
      })

    }, ['advisors', 'employers', 'educators'].reduce(function (obj, key) {
      return (0, _extends4.default)({}, obj, (0, _defineProperty3.default)({}, key, (0, _arrayAsObj2.default)(response[key], function (row) {
        var locationKey = key.substring(0, key.length - 1);
        return {
          locations: row[locationKey + 'Locations'],
          slug: '/' + key.slice(0, -1) + '/' + row.slug
        };
      })));
    }, {}));
  }
}), _typeToReducer), initialState);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/reducers/data/index.js
// module id = 1288
// module chunks = 0